import { Component, OnInit } from '@angular/core';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { ProductsService } from '../../services/products.service';
import { DeviceInterface, DevicesClassInterface } from '../../interfaces/device.interface';
import { ToastsManager } from 'ng2-toastr';
import { AddDeviceDialogComponent } from './add-device/add-device-dialog.component';
import { DevicesService } from '../../services/devices.service';
import { DeviceTypeEnum } from '../../enums/devices.enum';
import { TranslateService } from '@ngx-translate/core';
import { filter, switchMap } from 'rxjs/operators';
import { ConfirmationDialogComponent } from '../../shared/components/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss']
})
export class DevicesComponent implements OnInit {
  public classes: DevicesClassInterface[] = [];
  public displayedColumns: string[] = ['name', 'code', 'description', 'tags'];
  public dataSource: MatTableDataSource<DeviceInterface>[] = [];
  public isExpansionPanelOpen: boolean[] = [];
  public filterValue = '';
  isLoading = false;

  constructor(
    private productsService: ProductsService,
    private devicesService: DevicesService,
    private toastr: ToastsManager,
    private dialog: MatDialog,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    this.isLoading = true;

    this.devicesService.getDevices({}).subscribe(classes => {
      this.classes = classes;
      classes.forEach(deviceClass => {
        this.isExpansionPanelOpen.push(false);
        this.dataSource.push(new MatTableDataSource(deviceClass.devices));
      });

      this.isLoading = false;
    });
  }

  addNewClass(): void {
    this.dialog
      .open(AddDeviceDialogComponent, {
        disableClose: true,
        data: {
          type: DeviceTypeEnum.CLASS
        }
      })
      .afterClosed()
      .subscribe(device => {
        if (device) {
          this.isExpansionPanelOpen.push(false);
          this.classes.push(device);
          this.dataSource.push(new MatTableDataSource());
          return this.toastr.success(this.translate.instant('DEVICES.COMPONENT.CLASS_ADDED'));
        }
      });
  }

  addNewDevice(deviceClass: DevicesClassInterface, index: number): void {
    this.dialog
      .open(AddDeviceDialogComponent, {
        disableClose: true,
        data: {
          type: DeviceTypeEnum.DEVICE,
          deviceClass: deviceClass
        }
      })
      .afterClosed()
      .subscribe(device => {
        if (device) {
          this.dataSource[index].data = deviceClass.devices;
          return this.toastr.success(this.translate.instant('DEVICES.COMPONENT.DEVICE_ADDED'));
        }
      });
  }

  deleteClass(index: number, className: string): void {
    this.dialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: 'DEVICES.DEVICE_CLASS.DELETE_DIALOG.TITLE',
          body: 'DEVICES.DEVICE_CLASS.DELETE_DIALOG.BODY',
          translateParams: { className }
        }
      })
      .afterClosed()
      .pipe(
        filter(v => v),
        switchMap(() => this.devicesService.deleteDevice(this.classes[index]))
      )
      .subscribe(device => {
        this.isExpansionPanelOpen.splice(index, 1);
        this.classes.splice(index, 1);
        this.dataSource.splice(index, 1);
        return this.toastr.success(this.translate.instant('DEVICES.COMPONENT.CLASS_REMOVED'));
      });
  }

  deleteDevice(classIndex: number, device: DeviceInterface): void {
    const deviceClass = this.classes[classIndex];

    this.dialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: 'DEVICES.DEVICE.DELETE_DIALOG.TITLE',
          body: 'DEVICES.DEVICE.DELETE_DIALOG.BODY',
          translateParams: { deviceName: device.name }
        }
      })
      .afterClosed()
      .pipe(
        filter(v => v),
        switchMap(() => {
          const deviceIndex = deviceClass.devices.findIndex(element => element === device);
          deviceClass.devices.splice(deviceIndex, 1);
          return this.devicesService.updateDevice(deviceClass);
        })
      )
      .subscribe(() => {
        this.dataSource[classIndex].data = deviceClass.devices;
        return this.toastr.success(this.translate.instant('DEVICES.COMPONENT.DEVICE_REMOVED'));
      });
  }

  filterDevices(value: string): void {
    let index = 0;
    this.filterValue = value;
    this.classes.forEach(deviceClass => {
      this.isExpansionPanelOpen[index] = true;
      this.dataSource[index].data = deviceClass.devices.filter(device => device.tags.find(tag => tag.includes(value)));
      index++;
    });
  }

  openEditDeviceDialog(device: DeviceInterface, deviceClass: DevicesClassInterface, index: number) {
    this.dialog
      .open(AddDeviceDialogComponent, {
        data: {
          type: DeviceTypeEnum.DEVICE,
          editingDevice: device,
          deviceClass
        }
      })
      .afterClosed()
      .pipe(filter(v => !!v))
      .subscribe((editedDevice: DevicesClassInterface) => {
        this.dataSource[index].data = editedDevice.devices;
        this.classes[index] = editedDevice;
        this.isExpansionPanelOpen[index] = true;
        return this.toastr.success(this.translate.instant('DEVICES.COMPONENT.DEVICE_ADDED'));
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/devices/devices.component.ts